import React from "react";

const items = [
    "GET SAVED BRO",
    "DAILY · 12AM EST",
    "ONLY ON KICK",
    "@LEONARDTHEPREACHER",
    "MIAMI ⟶ NOLA",
    "STREET MINISTRY",
];

export const ScheduleBanner = () => {
    const repeated = [...items, ...items, ...items];
    return (
        <section
            data-testid="schedule-banner"
            className="relative bg-kickgreen border-y-4 border-black overflow-hidden -rotate-1 my-12"
        >
            <div className="flex whitespace-nowrap animate-ticker py-3 will-change-transform">
                {repeated.map((t, i) => (
                    <div
                        key={i}
                        className="font-anton uppercase tracking-tight text-3xl md:text-5xl text-black px-6 flex items-center gap-6"
                    >
                        <span>{t}</span>
                        <span className="text-hotpink">✦</span>
                    </div>
                ))}
            </div>
        </section>
    );
};
